import gql from 'graphql-tag';
import collegeEventLocationFragment from './collegeEventLocationFragment';

export default gql`
  mutation createCollegeEventLocation($input: createCollegeEventLocationInput!) {
    createCollegeEventLocation(input: $input) {
      viewer {
        id
        eventLocations {
          ...CollegeEventLocation
        }
      }
      collegeEventLocation {
        ...CollegeEventLocation
      }
    }
  }
  ${collegeEventLocationFragment}
`;
